module.exports = {
  latlng: [51.375899, 7.699205],
  zoom: 15,
  title: 'Unsere Region als Häusermeer',
  introtext:'Wie gut kennen Sie sich im Sauerland und Südwestfalen aus? Erkennen Sie Orte nur anhand der Gebäudeumrisse? Machen Sie das Häuserquiz und ordnen Sie den neun Häuserkarten die richtigen Orte zu. Zu jedem Ausschnitt gibt es einen kleinen Tipp.',
  resultSentences: [
    'Sie waren höchstens mal auf der Durchfahrt hier.',
    'Tourist? Beruflich unterwegs? Sie leben bestimmt nicht hier.',
    'Immerhin kennen Sie ein paar Ecken in der Region.',
    'Nicht schlecht. Sie kennen sich halbwegs aus hier.',
    'Wow! Alles richtig. Sie wirklich ein Experte für die Region.'
  ],
  questions: [
    {
      id: 'WP 1',
      lat: 51.38729,
      lng: 7.38732,
      zoom: 14,
      answers: [
        'Wetter',
        'Ennepetal',
        'Schwelm'
      ],
      correctAnswer: 'Wetter',
      description: 'Der Name „Harkort“ ist in dieser Stadt Programm.'
    },
    {
      id: 'WP 2',
      lat: 51.437173,
      lng: 7.795739,
      zoom: 15,
      answers: [
        'Menden',
        'Soest',
        'Brilon'
      ],
      correctAnswer: 'Menden',
      description: 'Diese Stadt ist auch als Hönnestadt bekannt.'
    },
    {
      id: 'WP 3',
      lat: 51.148581,
      lng: 8.28514,
      zoom: 15,
      answers: [
        'Schmallenberg',
        'Winterberg',
        'Bad Berleburg'
      ],
      correctAnswer: 'Schmallenberg',
      description: 'Es ist die flächengrößte kreisangehörige Stadt Nordrhein-Westfalens.'
    },
    {
      id: 'WP 4',
      lat: 51.029073,
      lng: 7.844769,
      zoom: 15,
      answers: [
        'Olpe',
        'Lennestadt',
        'Herdecke'
      ],
      correctAnswer: 'Olpe',
      description: 'Hier gibt es zum Schützenfest das traditionelle Beff.'
    },
    {
      id: 'WP 5',
      lat: 50.8745,
      lng: 8.01686,
      zoom: 15,
      answers: [
        'Siegen',
        'Bad Laasphe',
        'Balve'
      ],
      correctAnswer: 'Siegen',
      description: 'Seit 2007 hat die Stadt mit dem Apollo ihr erstes eigenes Theater.'
    },
    {
      id: 'WP 6',
      lat: 51.358813,
      lng: 7.474085,
      zoom: 15,
      answers: [
        'Hagen',
        'Attendorn',
        'Olsberg'
      ],
      correctAnswer: 'Hagen',
      description: 'Die Stadt wird auch Tor zum Sauerland genannt.'
    },
    {
      id: 'WP 7',
      lat: 51.397082,
      lng: 8.063487,
      zoom: 15,
      answers: [
        'Arnsberg',
        'Warstein',
        'Eslohe'
      ],
      correctAnswer: 'Arnsberg',
      description: 'In der Stadt befindet sich das Sauerland-Museum.'
    },
    {
      id: 'WP 8',
      lat: 51.37423,
      lng: 7.69906,
      zoom: 15,
      answers: [
        'Iserlohn',
        'Gevelsberg',
        'Bad Fredeburg'
      ],
      correctAnswer: 'Iserlohn',
      description: 'Hier findet die Wirtschaftskonferenz Campus Symposium statt.'
    },
    {
      id: 'WP 9',
      lat: 51.348193,
      lng: 8.280633,
      zoom: 15,
      answers: [
        'Meschede',
        'Neheim-Hüsten',
        'Winterberg'
      ],
      correctAnswer: 'Meschede',
      description: 'In einem Ortsteil der Stadt ist der Sitz der Veltins-Brauerei.'
    }
  ]
}